import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Typography, InputLabel, FormControl, FormHelperText } from '@material-ui/core'
import { externalEntityGroupBulkImportFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useStyles } from './Styles'
import Configuration from '../../../../../Services/Api/Configuration'
import { ExcelIcon } from '../../../../../utils/helpers'
import externalEntityGroupTemplate from '../../../../../assets/externalEntityGroupsBulkTemplate.xlsx'

const ExternalEntityGroupBulkImportForm = ({ onSubmit, cancelDialog, bulkImportHasError, clearBulkImportError, reloadPage }) => {
  const intl = useIntl()
  const classes = useStyles()
  const [filesName, setFilesName] = React.useState(intl.formatMessage({ id: 'ExternalEntityGroupBulkImport.placeholder.file' }))

  const externalEntityGroupBulkImportFormActions = useFormik({
    initialValues: {
      externalEntityGroupsFile: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: externalEntityGroupBulkImportFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, cancelDialog, reloadPage)
    })
  })

  const handleFileChange = (event, fieldName) => {
    event.preventDefault()
    clearBulkImportError()
    let files = event.currentTarget.files
    if (files && files.length > 0) {
      if (!!externalEntityGroupBulkImportFormActions.errors[fieldName]) {
        externalEntityGroupBulkImportFormActions.setFieldError(fieldName, null)
      }
      let file = files[0]
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      if (types.includes(file.type)) {
        if (file.size <= Configuration.UPLOAD_FILE_SIZE) {
          externalEntityGroupBulkImportFormActions.setFieldValue(fieldName, file)
          setFilesName(event.target.value.replace(/.*(\/|\\)/, ''))
        } else {
          externalEntityGroupBulkImportFormActions.setFieldTouched(fieldName, true, true)
          setTimeout(() => externalEntityGroupBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.largeFile' })), 50)
        }
      } else {
        externalEntityGroupBulkImportFormActions.setFieldTouched(fieldName, true, true)
        setTimeout(() => externalEntityGroupBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.unSupported' })), 50)
      }
    }
  }

  // Reset file input when there's an error
  React.useEffect(() => {
    if (bulkImportHasError) {
      externalEntityGroupBulkImportFormActions.setFieldTouched('externalEntityGroupsFile', false)
      externalEntityGroupBulkImportFormActions.setFieldValue('externalEntityGroupsFile', null)
      setFilesName(intl.formatMessage({ id: 'ExternalEntityGroupBulkImport.placeholder.file' }))
      const fileInput = document.getElementById('externalEntityGroupsFile')
      if (fileInput) {
        fileInput.value = ''
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkImportHasError])

  return (
    <form onSubmit={externalEntityGroupBulkImportFormActions.handleSubmit} noValidate autoComplete="off"
      className={classes.formWrapper}>
      <>
        <Typography className={classes.templateTitle} variant={'h6'}>
          <FormattedMessage id='ExternalEntityGroupBulkImport.template.title' />
        </Typography>

        <div className={classes.templateDownloadWrapper}>
          <Button
            className={classes.templateDownload}
            color={'primary'}
            startIcon={<ExcelIcon htmlColor="#fff" />}
            href={externalEntityGroupTemplate}
            download='externalEntityGroupsBulkTemplate.xlsx'
          >
            externalEntityGroupsBulkTemplate.xlsx
          </Button>
        </div>

        <div className={classes.BasicInfoRow}>
          <InputLabel htmlFor="externalEntityGroupsFile">
            <FormattedMessage id='ExternalEntityGroupBulkImport.label.file' />
            <span className={'required'}>*</span>:
          </InputLabel>
          <FormControl variant="outlined" margin="dense">
            <div className={classes.fileUploadWrapper} data-text={filesName}>
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                className={classes.fileUpload}
                name="externalEntityGroupsFile"
                id="externalEntityGroupsFile"
                type="file"
                onChange={(event) => handleFileChange(event, 'externalEntityGroupsFile')}
              />
            </div>
            {externalEntityGroupBulkImportFormActions.errors.externalEntityGroupsFile && externalEntityGroupBulkImportFormActions.touched.externalEntityGroupsFile && (
              <FormHelperText error={true}>{externalEntityGroupBulkImportFormActions.errors.externalEntityGroupsFile}</FormHelperText>
            )}
          </FormControl>
        </div>
      </>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size='large' color='primary'
          onClick={externalEntityGroupBulkImportFormActions.handleSubmit}
          disabled={externalEntityGroupBulkImportFormActions.isSubmitting || !externalEntityGroupBulkImportFormActions.isValid}
        >
          <FormattedMessage id='ExternalEntityGroupBulkImport.button.submit' />
        </Button>
      </div>
      {!!externalEntityGroupBulkImportFormActions.isSubmitting && <FormLoader loading={true} />}
    </form>
  )
}

export default ExternalEntityGroupBulkImportForm

